import { Button, DataSource, Layout, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutlayout_dimuxref extends Layout {
    buttonButton1: Button;
    sourceDimuidents: DataSource;
    sourceDimuxref: DataSource;
    tblMobileUserXref: Table;
    textboxDimuiDesc: Textbox;
    textboxDimuiIdent: Textbox;
    textboxDimuxLogin: Textbox;
}
